import { Blockchain } from "@rarible/api-client"
import { telos } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const telosConfig: StaticEthereumBlockchainConfig = {
  name: "Telos",
  icon: "/images/blockchains/telos.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  unionApi: "https://api.rarible.org",
  basePath: "https://telos-api.rarible.org",
  chainId: telos.id,
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  blockchain: Blockchain.TELOS,
  chainName: telos.name,
  exchange: {
    v2: "0x5faf16A85028BE138A7178B222DeC98092FEEF97",
    wrapper: "0xF965237c6b3f89f8C62B45b94097899E3562A830",
  },
  blockExplorers: [
    {
      url: "https://www.teloscan.io",
      icon: "/images/scanner.svg",
      adress: "https://www.teloscan.io/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "telos-node",
  transferProxies: {
    nft: "0xF65eF65a95821A16E02973b1C2200FA58898e3c0",
    erc721Lazy: "0xce4bf732f53A76C463aE8822be858017b02779c8",
    erc20: "0x248B46BEB66b3078D771a9E7E5a0a0216d0d07ba",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("TELOS:0x0000000000000000000000000000000000000000"),
    symbol: "TLOS",
    name: "Telos",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("TELOS:0xd102ce6a4db07d247fcc28f366a623df0938ca9e"),
    symbol: "WTLOS",
    name: "Wrapped Telos",
    decimals: 18,
  },
  addFundsLink: "https://bridge.telos.net/",
  hasStabilityProtocol: false,
  viem: telos,
}

export const getTelosConfig = (): StaticEthereumBlockchainConfig => telosConfig
